import React from 'react';
import {List} from 'antd';
import SummaryCard from './SummaryCard';
import AppointmentItem from '@/components/ProjectDetails/Cards/Items/AppointmentItem';
import {F} from '@/utils/intl';
import {LeadDetailsModel} from '@/typings/models/Lead';

export interface AppointmentsCardProps {
  appointments: any[];
  count: number;
  highlightedAppointmentId?: string;
  leadData?: LeadDetailsModel;
  onAdd?: () => void;
  onRefresh?: () => void;
  onShowAll?: () => void;
}

const AppointmentsCard: React.FC<AppointmentsCardProps> = ({
  appointments,
  count,
  highlightedAppointmentId,
  leadData,
  onRefresh,
  onAdd,
  onShowAll,
}) => {
  return (
    <SummaryCard
      title={
        <F id={'entity.appointment.plural'} defaultMessage={'Appointments'} />
      }
      count={count}
      onAdd={onAdd}
      onShowAll={onShowAll}
    >
      <List
        dataSource={appointments}
        renderItem={(appointment) => (
          <AppointmentItem
            lead={leadData}
            fadePastEvent
            appointment={appointment}
            highlighted={appointment.id === highlightedAppointmentId}
            refresh={onRefresh}
          />
        )}
      />
    </SummaryCard>
  );
};

export default AppointmentsCard;
